import Map from "./components/map/Map";
import { USER_DASHBOARD_HEIGHT } from "../../constants/insight";

export function Component() {

  return (
    <div style={{ height: `${USER_DASHBOARD_HEIGHT}vh`, position: "relative" }}>
      <Map />
    </div>
  );
}
